module.exports = __webpack_public_path__ + "static/media/ugli.252a1e61.png";